<template>
  <base-container
    ref="container"
    style="display: flex; overflow: hidden; align-items: center"
    :isLoading="loading"
  >
    <artisan-group style="height: 100%; width: 48%" title="院区-病区">
      <el-tree
        ref="hosWard"
        default-expand-all
        :data="wardTree"
        node-key="id"
        :props="defaultProps"
        @node-click="handleWardNodeClick"
      ></el-tree>
    </artisan-group>
    <span
      style="width: 4%; text-align: center"
      class="el-icon-d-arrow-right"
    ></span>
    <artisan-group style="height: 100%; flex: 1" :title="groupTitle">
      <el-tree
        :data="groupTree"
        node-key="id"
        default-expand-all
        :props="defaultProps"
        @node-click="handleGroupNodeClick"
      ></el-tree>
    </artisan-group>
  </base-container>
</template>

<script>
import { all } from "@/api/basis/hos";
import { list, getWardGroups } from "@/api/bed/ward";
export default {
  props: {
    isHos: Boolean,
    hosId: String,
    wardId: String,
  },
  data() {
    return {
      loading: false,
      hosList: [],
      wards: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      selWardId: this.wardId,
      selGroupId: "",
      wardTree: [],
      wardGroups: [],
    };
  },
  computed: {
    groupTitle() {
      let title = "医疗组";
      if (this.selWardId) {
        let ward = this.wards.find((c) => c.id == this.selWardId);
        if (ward) {
          title = ward.name + "--" + title;
        }
      }
      return title;
    },
    groupTree() {
      let leaders = this.wardGroups.filter((c) => c.groupId == "0");
      leaders.forEach((c) => {
        c.children = this.wardGroups.filter((g) => g.groupId == c.id);
      });
      return leaders;
    },
  },
  mounted() {
    return this.loadWard();
  },
  methods: {
    loadWard() {
      all()
        .then((res) => {
          this.hosList = res.data.data;
          return list();
        })
        .then((res) => {
          this.wards = res.data.data;
          this.wardTree = this.buildWardTree();
        });
      this.loadWardGroup();
    },
    loadWardGroup() {
      if (this.selWardId) {
        getWardGroups(this.selWardId).then((res) => {
          this.wardGroups = res.data.data;
        });
      }
    },
    buildWardTree() {
      let wardArr = [];
      this.hosList.forEach((c) => {
        if (this.isHos || (!this.isHos && c.id == this.hosId)) {
          c.type = "hos";
          c.children = [];
          this.wards
            .filter((w) => w.hosId == c.id)
            .forEach((w) => {
              w.type = "ward";
              c.children.push(w);
            });
          wardArr.push(c);
        }
      });
      return wardArr;
    },
    handleWardNodeClick(data) {
      if (data.type == "ward") {
        this.selWardId = data.id;
        this.loadWardGroup();
      }
    },
    handleGroupNodeClick(data) {
      this.selGroupId = data.id;
    },
    getSelGroupId() {
      return this.selGroupId;
    },
  },
};
</script>

<style scoped></style>
